module.exports = __webpack_public_path__ + "cow.jpg?726ad5aab124ac2e0827cc9cbe447be6";